"use client";
import React from "react";
import { DCAuth } from "./DCAuthProvider";
import { DCAuthProviderProps } from "./types";

/**
 * Wrapper de Client Components para preservar SSR
 * Usa este componente en lugar de DCAuth directamente en tu layout
 */
export const ClientProviders: React.FC<DCAuthProviderProps> = ({ 
  children, 
  config,
  callbacks 
}) => {
  return (
    <DCAuth config={config} callbacks={callbacks}>
      {children}
    </DCAuth>
  );
};
